module.exports = __webpack_public_path__ + "img/20240904_2.8ec834a4.jpg";